import * as React from "react";
import { IListFilterItem } from "../../../models/common/listFilterItem";
import { AppUtils } from "source/framework/appUtils";
import { Translations } from "ui/Scripts/source/models/translations";
import { Grid } from "@mui/material";
import { SaveDataObj } from "source/framework/saveData";
import { Base } from "ui/Scripts/source/framework/base";
import { FormField } from "ui/Scripts/source/components/framework/FormField";
import { GridRow } from "source/components/framework/Grid/GridRow";
import { CheckboxDropdown } from "ui/Scripts/source/components/framework/Dropdown/CheckboxDropdown";
import { FilterButtons } from "source/components/framework/Filters/FilterButtons";
import { DrawerContent } from "source/components/framework/Drawer/DrawerContent";
import { PageFilterConditionDrawer } from "source/components/framework/Page/PageFilterConditionDrawer";
import { DatePicker } from "source/components/framework/DateTime";
import { IdTitleDropdown } from "ui/Scripts/source/components/framework/Dropdown/IdTitleDropdown";
import { IDocumentPageFilterLists, IDocumentPageFilterState, IDocumentPageFilterStateWithoutDates } from "../DocumentPageDashboardChart";
import { FormRadio } from "source/components/framework/FormRadio";

//DocumentFilterDrawer
export interface IDocumentFilterDrawerProp extends IDocumentPageFilterLists, IDocumentPageFilterState {
    open: boolean;
    filter: IListFilterItem;
    canRemoveSharedFilters: boolean;
    onSaveFilter: (saveAs: boolean, onGetGeneralFilter: () => any) => void;
    onRemoveFilter: (filterId: string) => void;
    onOk: (closeDialog: boolean, filterState: IDocumentPageFilterState) => any;
    onCancel: () => void;
}

export interface IDocumentFilterDrawerState extends IDocumentPageFilterStateWithoutDates {
    startDateStr: string;
    endDateStr: string;
    startEndDateDisabled: boolean;
    documentEndDateStartDateStr: string;
    documentEndDateEndDateStr: string;
    documentEndDateStartEndDateDisabled: boolean;
}

export class DocumentFilterDrawer extends React.Component<IDocumentFilterDrawerProp, IDocumentFilterDrawerState> {
    private orgStateHash: string = "";

    getStateFromProps = (props: IDocumentFilterDrawerProp): IDocumentFilterDrawerState => {
        return {
            ...props,
            startDateStr: props.selectedStartDate ? Base.timeToDateStr(props.selectedStartDate) : "",
            endDateStr: props.selectedEndDate ? Base.timeToDateStr(props.selectedEndDate) : "",
            startEndDateDisabled: props.selectedDynamicTimeFilterId !== props.dynamicTimeFilters[0].id,
            documentEndDateStartDateStr: props.selectedDocumentEndDateStartDate ? Base.timeToDateStr(props.selectedDocumentEndDateStartDate) : "",
            documentEndDateEndDateStr: props.selectedDocumentEndDateEndDate ? Base.timeToDateStr(props.selectedDocumentEndDateEndDate) : "",
            documentEndDateStartEndDateDisabled: props.selectedDynamicDocumentEndDateFilterId !== props.documentEndDateDynamicTimeFilters[0].id,
        };
    };

    constructor(props: IDocumentFilterDrawerProp) {
        super(props);
        this.state = this.getStateFromProps(props);
        this.orgStateHash = this.getSaveDataFromState(props, this.state).hash;
    }

    componentDidUpdate(prevProps: IDocumentFilterDrawerProp, prevState: IDocumentFilterDrawerState): void {
        const props = this.props;
        const filterChanged = prevProps.filter?.getHash() !== props.filter?.getHash();
        const opened = !prevProps.open && props.open;
        if (!filterChanged && !opened) return;
        const state = this.getStateFromProps(props);
        this.setState(state);
        this.orgStateHash = this.getSaveDataFromState(props, state).hash;
    }

    // #region ModifyDate
    handleChangeDynamicTimeFilterId = (id: string) => {
        if (id.toInteger() > 0) {
            this.setState({ selectedDynamicTimeFilterId: id, startDateStr: "", endDateStr: "", startEndDateDisabled: true });
        } else {
            this.setState({ selectedDynamicTimeFilterId: id, startEndDateDisabled: false });
        }
    };

    handleStartDateChange = (startDateStr: string) => {
        this.setState({ startDateStr });
    };

    handleEndDateChange = (endDateStr: string) => {
        this.setState({ endDateStr });
    };
    // #endregion ModifyDate

    // #region DocumentEndDate
    handleChangeDynamicDocumentEndDateFilterId = (id: string) => {
        if (id.toInteger() > 0) {
            this.setState({ selectedDynamicDocumentEndDateFilterId: id, documentEndDateStartDateStr: "", documentEndDateEndDateStr: "", documentEndDateStartEndDateDisabled: true });
        } else {
            this.setState({ selectedDynamicDocumentEndDateFilterId: id, documentEndDateStartEndDateDisabled: false });
        }
    };

    handleDocumentEndDateStartDateChange = (documentEndDateStartDateStr: string) => {
        this.setState({ documentEndDateStartDateStr });
    };

    handleDocumentEndDateEndDateChange = (documentEndDateEndDateStr: string) => {
        this.setState({ documentEndDateEndDateStr });
    };
    // #endregion DocumentEndDate

    handleChangeKeywordIds = (selectedKeywordIds: string[]) => {
        this.setState({
            selectedKeywordIds
        });
    };

    getSaveDataFromState = (_props: IDocumentFilterDrawerProp, state: IDocumentFilterDrawerState): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("selectedKeywordIds", state.selectedKeywordIds);
        result.append("selectedKeywordOperatorId", state.selectedKeywordOperatorId);
        result.append("selectedDocumentApprovalId", state.selectedDocumentApprovalId);
        result.append("selectedDocumentContentSearchId", state.selectedDocumentContentSearchId);
        result.append("selectedMaxResultsCount", state.selectedMaxResultsCount);
        result.append("startDate", state.startDateStr);
        result.append("endDate", state.endDateStr);
        result.append("selectedDynamicTimeFilterId", state.selectedDynamicTimeFilterId ? state.selectedDynamicTimeFilterId : null);
        result.append("documentEndDateStartDate", state.documentEndDateStartDateStr);
        result.append("documentEndDateEndDate", state.documentEndDateEndDateStr);
        result.append("selectedDynamicTimeFilterId", state.selectedDynamicDocumentEndDateFilterId ? state.selectedDynamicDocumentEndDateFilterId : null);
        return result;
    };

    static filterIsSet = (filterLists: IDocumentPageFilterLists, filterState: IDocumentPageFilterState): boolean => {
        return !!filterState.selectedStartDate || !!filterState.selectedEndDate ||
            !!filterState.selectedDocumentEndDateStartDate || !!filterState.selectedDocumentEndDateEndDate ||
            !(filterState.selectedKeywordOperatorId === "0" &&
                filterState.selectedDocumentApprovalId === "0" &&
                filterState.selectedDocumentContentSearchId === "1" &&
                filterState.selectedMaxResultsCount === "100" &&
                Base.equalStrArrays(filterState.selectedKeywordIds, []) &&
                filterState.selectedDynamicTimeFilterId === filterLists.dynamicTimeFilters[0].id &&
                filterState.selectedDynamicDocumentEndDateFilterId === filterLists.documentEndDateDynamicTimeFilters[0].id);
    };

    getSaveFilterState = (): IDocumentPageFilterState => {
        const state = this.state;
        const selectedStartDate = state.startDateStr ? state.startDateStr.toUtcDate().getTime() : null;
        const selectedEndDate = state.endDateStr ? state.endDateStr.toUtcDate().getTime() : null;
        const selectedDocumentEndDateStartDate = state.documentEndDateStartDateStr ? state.documentEndDateStartDateStr.toUtcDate().getTime() : null;
        const selectedDocumentEndDateEndDate = state.documentEndDateEndDateStr ? state.documentEndDateEndDateStr.toUtcDate().getTime() : null;
        return { ...state, selectedStartDate, selectedEndDate, selectedDocumentEndDateStartDate, selectedDocumentEndDateEndDate };
    };

    handleSaveFilter = async (saveAs: boolean) => {
        const props = this.props;
        const filterState = this.getSaveFilterState();
        if (!saveAs) {
            props.onOk(false, filterState);
            await this.props.onSaveFilter(false, null);
        } else {
            await this.props.onSaveFilter(true, () => {
                return props.onOk(false, filterState);
            });
        }
    };

    static getClearedParametersState = (props: IDocumentPageFilterLists) => {
        return {
            selectedKeywordIds: [],
            selectedKeywordOperatorId: "0",
            selectedDocumentApprovalId: "0",
            selectedDocumentContentSearchId: "1",
            selectedMaxResultsCount: "100",
            startDateStr: "",
            endDateStr: "",
            selectedDynamicTimeFilterId: props.dynamicTimeFilters[0].id,
            documentEndDateStartDateStr: "",
            documentEndDateEndDateStr: "",
            selectedDynamicDocumentEndDateFilterId: props.documentEndDateDynamicTimeFilters[0].id
        };
    };

    handleClear = () => {
        this.setState(
            DocumentFilterDrawer.getClearedParametersState(this.props)
        );
    };

    handleSave = async () => {
        this.props.onOk(true, this.getSaveFilterState());
    };

    handleCancel = async (checkChanges: boolean) => {
        AppUtils.cancelEditDialog(checkChanges, this.getSaveDataFromState(this.props, this.state).hash, this.orgStateHash, this.handleSave, this.props.onCancel, Translations.YouHaveUnapprovedChangesDoYouWantApproveChanges);
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <PageFilterConditionDrawer
                open={props.open}
                onClose={() => this.handleCancel(false)}
            >
                <DrawerContent
                    content={
                        <>
                            {/* {!!props.onSaveFilter && !!props.onRemoveFilter &&
                                <FilterSearchField
                                    filter={props.filter}
                                    canRemoveSharedFilters={props.canRemoveSharedFilters}
                                    onSaveFilter={props.onSaveFilter ? this.handleSaveFilter : null}
                                    onRemoveFilter={props.onRemoveFilter}
                                />
                            } */}
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.ModifyDate} margin={0}>
                                        <IdTitleDropdown
                                            selectedId={state.selectedDynamicTimeFilterId}
                                            items={props.dynamicTimeFilters}
                                            onChange={this.handleChangeDynamicTimeFilterId}
                                        />
                                    </FormField>
                                </Grid>
                            </GridRow>
                            <GridRow>
                                <Grid item sm={6}>
                                    <FormField title={null}>
                                        <DatePicker
                                            value={state.startDateStr}
                                            disabled={state.startEndDateDisabled}
                                            onChange={this.handleStartDateChange}
                                        />
                                    </FormField>
                                </Grid>
                                <Grid item sm={6}>
                                    <FormField title={null}>
                                        <DatePicker
                                            value={state.endDateStr}
                                            disabled={state.startEndDateDisabled}
                                            onChange={this.handleEndDateChange}
                                        />
                                    </FormField>
                                </Grid>
                            </GridRow>
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.DocumentEndDate}>
                                        <IdTitleDropdown
                                            selectedId={state.selectedDynamicDocumentEndDateFilterId}
                                            items={props.documentEndDateDynamicTimeFilters}
                                            onChange={this.handleChangeDynamicDocumentEndDateFilterId}
                                        />
                                    </FormField>
                                </Grid>
                            </GridRow>
                            <GridRow>
                                <Grid item sm={6}>
                                    <FormField title={null}>
                                        <DatePicker
                                            value={state.documentEndDateStartDateStr}
                                            disabled={state.documentEndDateStartEndDateDisabled}
                                            onChange={this.handleDocumentEndDateStartDateChange}
                                        />
                                    </FormField>
                                </Grid>
                                <Grid item sm={6}>
                                    <FormField title={null}>
                                        <DatePicker
                                            value={state.documentEndDateEndDateStr}
                                            disabled={state.documentEndDateStartEndDateDisabled}
                                            onChange={this.handleDocumentEndDateEndDateChange}
                                        />
                                    </FormField>
                                </Grid>
                            </GridRow>
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.Keywords}>
                                        <GridRow>
                                            <Grid item sm={12}>
                                                <FormRadio
                                                    title={Translations.KeywordsOrCondition}
                                                    checked={state.selectedKeywordOperatorId === "0"}
                                                    onChange={(checked: boolean) => { this.setState({ selectedKeywordOperatorId: checked ? "0" : "1" }); }}
                                                />
                                            </Grid>
                                        </GridRow>
                                        <GridRow>
                                            <Grid item sm={12}>
                                                <FormRadio
                                                    title={Translations.KeywordsAndCondition}
                                                    checked={state.selectedKeywordOperatorId === "1"}
                                                    onChange={(checked: boolean) => { this.setState({ selectedKeywordOperatorId: checked ? "1" : "0" }); }}
                                                />
                                            </Grid>
                                        </GridRow>
                                        <CheckboxDropdown
                                            required={true}
                                            selectedIds={state.selectedKeywordIds}
                                            toggleAll={false}
                                            values={props.keywords}
                                            onChange={this.handleChangeKeywordIds}
                                        />
                                    </FormField>
                                </Grid>
                            </GridRow>
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.DocumentApproval}>
                                        <IdTitleDropdown
                                            selectedId={state.selectedDocumentApprovalId}
                                            items={[{ id: "0", title: Translations.NotInUse }, { id: "1", title: Translations.NotApproved }, { id: "2", title: Translations.Approved }]}
                                            onChange={(id: string) => this.setState({ selectedDocumentApprovalId: id })}
                                        />
                                    </FormField>
                                </Grid>
                            </GridRow>
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.DocumentContentsSearch}>
                                        <IdTitleDropdown
                                            selectedId={state.selectedDocumentContentSearchId}
                                            items={[{ id: "0", title: Translations.NotInUse }, { id: "1", title: Translations.InUse }]}
                                            onChange={(id: string) => this.setState({ selectedDocumentContentSearchId: id })}
                                        />
                                    </FormField>
                                </Grid>
                            </GridRow>
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.MaxSearchResultCount}>
                                        <IdTitleDropdown
                                            selectedId={state.selectedMaxResultsCount}
                                            items={[{ id: "10", title: "10" }, { id: "25", title: "25" }, { id: "50", title: "50" }, { id: "100", title: "100" }, { id: "250", title: "250" }, { id: "500", title: "500" }, { id: "1000", title: "1000" }]}
                                            onChange={(id: string) => this.setState({ selectedMaxResultsCount: id })}
                                        />
                                    </FormField>
                                </Grid>
                            </GridRow>
                        </>
                    }
                    actions={
                        <FilterButtons
                            onSave={this.handleSave}
                            onCancel={this.handleCancel}
                            onClear={this.handleClear}
                        />
                    }
                />
            </PageFilterConditionDrawer>
        );
    }
}
